import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */

export class TrackingEventFavoriteAdShareMapper extends Mapper {
  constructor({config}) {
    super()

    this._config = config

    this._TRACKING_EVENT_NAMES = this._config.get('tracking').TRACKING_EVENT_NAMES
    this._TRACKING_EVENT_HIT_ORIGINS = this._config.get('tracking').HIT_ORIGINS
  }

  setParams({pageName}) {
    this._pageName = pageName
    return this
  }

  isForDetailPage() {
    const {ADS_DETAIL_PAGE_NAME} = this._config.get('page')

    return this._pageName === ADS_DETAIL_PAGE_NAME
  }

  mapAdSharedEvent() {
    return {
      event: this._TRACKING_EVENT_NAMES.AD_SHARED,
      data: {
        hit_origin: this.isForDetailPage() ? this._TRACKING_EVENT_HIT_ORIGINS.AD_SHARED_AFTER_FAVORITED_DETAIL : ''
      }
    }
  }

  mapAdShareModalClosedEvent() {
    return {
      event: this._TRACKING_EVENT_NAMES.AD_SHARE_MODAL_CLOSED,
      data: {
        hit_origin: this.isForDetailPage() ? this._TRACKING_EVENT_HIT_ORIGINS.AD_DETAIL_FAVORITED : ''
      }
    }
  }

  mapAdShareModalDeclineEvent() {
    return {
      event: this._TRACKING_EVENT_NAMES.AD_SHARE_DECLINE,
      data: {
        hit_origin: this.isForDetailPage() ? this._TRACKING_EVENT_HIT_ORIGINS.AD_DETAIL_FAVORITED : ''
      }
    }
  }

  mapAdShareModalRejectEvent() {
    return {
      event: this._TRACKING_EVENT_NAMES.AD_SHARE_MODAL_REJECT,
      data: {
        hit_origin: this.isForDetailPage() ? this._TRACKING_EVENT_HIT_ORIGINS.AD_DETAIL_FAVORITED : ''
      }
    }
  }

  map(eventName) {
    switch (eventName) {
      case this._TRACKING_EVENT_NAMES.AD_SHARED:
        return this.mapAdSharedEvent()

      case this._TRACKING_EVENT_NAMES.AD_SHARE_MODAL_CLOSED:
        return this.mapAdShareModalClosedEvent()

      case this._TRACKING_EVENT_NAMES.AD_SHARE_DECLINE:
        return this.mapAdShareModalDeclineEvent()

      case this._TRACKING_EVENT_NAMES.AD_SHARE_MODAL_REJECT:
        return this.mapAdShareModalRejectEvent()

      default:
        return {event: eventName}
    }
  }
}
